<template>
  <div class="login u-overlay u-row u-middle">
    <div class="u-row u-center u-relative u-full-width">
      <div class="u-w6of12 u-w8of12--sm u-pad-b-xl--sm">
        <img src="/images/sopra-logo.png" alt="Logo img" class="u-full-width"/>
      </div>
    </div>
    <div class="login__cta u-row u-center u-pad-x-sm">
      <app-button :ghost="true" :hasGradientBorder="true" @click="onFirst">{{$t('login.first')}}</app-button>
      <app-button @click="onSignin" class="u-marg-l-lg u-marg-l-sm--sm" >{{$t('login.back')}}</app-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onFirst () {
      this.$ga.send('Menu', 'Click', 'First time')
      this.$router.push(this.$local('create')) 
    },
    onSignin () {
      this.$ga.send('Menu', 'Click', 'I\'m back')
      this.$router.push(this.$local('signin')) 
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/settings/variables'

.login
  &__cta
    position absolute
    left 0
    width 100%
    bottom $spacings.xxl
</style>
